import React from 'react'
import JobActivityCard from '../history/job-activity-card'
import JobActivityTask from '../history/job-activity-task'
import CircleDate from '../history/circle-date'
import Address from '../shared/address'
import JobDetailsModal from '../modals/task-details-modal'
import TaskEditModal from '../modals/task-edit-modal'
import UpgradeServiceModal from '../modals/upgrade-service-modal'
import UpgradeFrequencyModal from '../modals/upgrade-frequency-modal'
import UpdateInstructionsModal from '../modals/update-instructions-modal'
import {fetchJobHistory, fetchTaskPrices} from '../api'
import ReactGA from 'react-ga'
import SkipJobModal from '../modals/skip-job-modal'
import NotificationModal from '../modals/notification-modal'
import JobFinishedModal from '../modals/job-finished-modal'
import DeclineTaskModal from '../modals/decline-task-modal'
import AcceptTaskModal from '../modals/accept-task-modal'


let colors = ['#54c2a4', '#37b6d5', '#4c8ae8', '#6e66b6', '#a47ab3']
let colorNum = 0


function check (num) {
  if (num === colors.length - 1) {
    num = 0
  } else {
    num++
  }
  colorNum = num
}

function isTaskLevelCard (card) {
  return card.backgroundColor
}

export default React.createClass({

  getInitialState: function () {
    return {
      authCode: '',
      cards: [],
      instructions: '',
      modalCard: this.props.initialData,
      loading: true,
      showAcceptTaskModal: false,
      showDeclineTaskModal: false,
      showEditTaskModal: false,
      showUpgradeServiceModal: false,
      showUpgradeScheduleModal: false,
      showUpdateInstructionsModal: false,
      showUpgradeFrequencyModal: false,
      showJobFinishedModal: false,
      showSkipJobModal: false,
      showNotificationModal: false,
      pricingArray: [],
      notificationTitle: '',
      notificationContent: '',
    }
  },
  componentDidMount: function () {
    this.refreshPage(this.props);
    if(this.state.pricingArray.length === 0) {
      let tempArray = [];
      fetchTaskPrices('MOWLAWN', this.props.currentAddress.addressId).then((data) => {
        for(let i = 0; i < data.data.length; i++) {
          tempArray.push(data.data[i]);
        }
        this.setState({pricingArray: tempArray});
      })
    }
  },
  componentDidUpdate: function(prevProps){
    if(this.props.currentAddress.addressId !== prevProps.currentAddress.addressId) {
      this.setState({cards:[], currentPage: 1, loading: true});
      this.refreshPage(this.props);
    }
  },
  refreshPage: function (props) {
    let address = this.props.currentAddress;
    if(props){
      address = props.currentAddress;
    }
    fetchJobHistory(address.addressId, 1).then((data) => {
      this.setState({cards: data, currentPage: 1, currentAddress: address.addressId, loading: false})
    })
    if (address != null) {
      let {addressId} = address
      if (addressId) this.setState({currentlySelectedAddressId: addressId})
    }
  },
  loadMoreHistory: function () {
    ReactGA.event({
      category: 'Load More History Button',
      action: 'click',
      label: 'Load More History'
    })
    this.setState({loading: true})
    let nextPage = this.state.currentPage + 1
    fetchJobHistory(this.state.currentAddress, nextPage).then((data) => {
      let newData = this.state.cards.concat(data)
      this.setState({cards: newData, currentPage: nextPage, loading: false})
    })
  },

  //Start of opening modals
  showJobDetailsModal: function (cardInfo) {
    ReactGA.pageview('JobDetailsModal');
    this.setState({showJobDetailsModal: true, modalCard: cardInfo})
  },
  closeJobDetailsModal: function () {
    this.setState({showJobDetailsModal: false})
  },
  openEditTaskModal: function (cardInfo) {
    ReactGA.pageview('EditTaskModal');
    this.setState({showEditTaskModal: true, showJobDetailsModal: false, modalTasks: cardInfo.modalCard})
  },
  closeEditTaskModal: function () {
    this.setState({showEditTaskModal: false})
  },
  openUpgradeServiceModal: function () {
    ReactGA.pageview('UpgradeServiceModal');
    this.setState({showUpgradeServiceModal: true, showEditTaskModal: false})
  },
  closeUpgradeServiceModal: function () {
    this.setState({showUpgradeServiceModal: false})
    this.refreshPage();
  },
  openUpgradeFrequencyModal: function () {
    ReactGA.pageview('UpgradeFrequencyModal');
    this.setState({showUpgradeFrequencyModal: true, showEditTaskModal: false})
  },
  closeUpgradeFrequencyModal: function () {
    this.setState({showUpgradeFrequencyModal: false})
    this.refreshPage();
  },
  openUpgradeScheduleModal: function () {
    ReactGA.pageview('UpgradeScheduleModal');
    this.setState({showUpgradeScheduleModal: true, showEditTaskModal: false})
  },
  closeUpgradeScheduleModal: function () {
    this.setState({showUpgradeScheduleModal: false})
  },
  openUpdateInstructionsModal: function() {
    ReactGA.pageview('UpdateInstructionsModal');
    this.setState({showUpdateInstructionsModal: true, showEditTaskModal: false})
  },
  closeUpdateInstructionsModal: function() {
    this.setState({showUpdateInstructionsModal: false})
    this.refreshPage();
  },
  openSkipJobModal: function () {
    ReactGA.pageview('SkipJobModal');
    this.setState({showSkipJobModal: true, showJobDetailsModal: false})
  },
  closeSkipJobModal: function () {
    this.setState({showSkipJobModal: false})
    this.refreshPage();
  },
  openNotificationModal: function(closingModal, notificationTitle, notificationContent) {
    ReactGA.pageview('NotificationModal');
    this.setState({showNotificationModal: true, [closingModal]: false, notificationTitle: notificationTitle, notificationContent: notificationContent})
  },
  closeNotificationModal: function() {
    this.setState({showNotificationModal: false})
  },
  openJobFinishedModal: function(card) {
    ReactGA.pageview('FinishedJobModal');
    this.setState({showJobFinishedModal: true, modalCard: card})
  },
  closeJobFinishedModal: function() {
    this.setState({showJobFinishedModal: false})
  },
  openDeclineTaskModal: function () {
    ReactGA.pageview('DeclineTaskModal');
    this.setState({ showDeclineTaskModal: true })
  },
  closeDeclineTaskModal: function () {
    this.setState({ showDeclineTaskModal: false })
    this.refreshPage();
  },
  openAcceptTaskModal: function (authCode, instructions, card) {
    ReactGA.pageview('AcceptTaskModal');
    this.setState({ showAcceptTaskModal: true, authCode: authCode, instructions: instructions, modalCard: card })
  },
  closeAcceptTaskModal: function () {
    this.setState({ showAcceptTaskModal: false })
  },
  //End of opening modals

  render: function () {
    let cardArray = this.state.cards
    let cardList = []

    if (cardArray && cardArray[0] !== undefined) {
      let idValue
      let border
      if (cardArray[0].mobileJob !== undefined) {
        idValue = cardArray[0].mobileJob.jobId
        border = true
      } else {
        idValue = 0
        border = false
      }
      let borderColor = colors[colorNum]
      for (let i = 0; i < cardArray.length; i++) {
        let show = () => this.showJobDetailsModal(cardArray[i])
        if(cardArray[i].subActivityType === 'FINISHED'){
          show = () => this.openJobFinishedModal(cardArray[i]);
        }
        else if(cardArray[i].subActivityType === 'JOB_CLOSED'){
          show = () => this.openJobFinishedModal(cardArray[i]);
        }
        // this does cards that aren't individual jobs
        if(cardArray.activityType !== 'TASK_CLOSED'){
          if (isTaskLevelCard(cardArray[i])) {
            cardList.push(
              <div key={i} className='row'>
                <div className='history-col-xs-2 visible-xs-block full-height-bar'>
                  <CircleDate cardDate={cardArray[i].date} color='#F3F3F3' fontColor='#5c5c5c' />
                </div>
                <div className='history-col-sm-11 history-col-xs-9 task-card' style={{zIndex: '5'}}>
                  <JobActivityTask key={i} card={cardArray[i]} />
                </div>
              </div>)
          }else if((cardArray[i].mobileJob && cardArray[i].mobileJob.jobId !== idValue)) {
            if (cardArray[i].mobileJob !== undefined) {
              idValue = cardArray[i].mobileJob.jobId
            }
            border = !border
            check(colorNum)
            borderColor = colors[colorNum]
            let overlap = 'overlap-style' // This stops the cards that are underneath transition cards from overlaping
            if (i !== 0 && isTaskLevelCard(cardArray[i - 1])) {
              overlap = ''
            }

            if (border) {// push first left card
              cardList.push(
                <div key={i} className='row'>
                  <div className='history-col-xs-2 visible-xs-block full-height-bar'>
                    <CircleDate cardDate={cardArray[i].date} color={borderColor} />
                  </div>
                  <div onClick={show} className={'history-col-sm-5 history-col-xs-9 left-card clickable ' + overlap} >
                    <JobActivityCard key={i} card={cardArray[i]} modalCard={cardArray[i]} show={show} border={border} borderColor={borderColor} />
                  </div>
                  <div className={'history-col-sm-1 hidden-xs ' + overlap} >
                    <CircleDate cardDate={cardArray[i].date} color={borderColor} />
                  </div>
                </div>)
            } else {
            // push first right card
            cardList.push(
              <div key={i} className='row'>
                <div className={'history-col-xs-2 history-col-sm-1 history-col-sm-offset-5 full-height-bar ' + overlap}>
                  <CircleDate cardDate={cardArray[i].date} color={borderColor} />
                </div>
                <div onClick={show} className={'history-col-sm-5 history-col-xs-9 right-card clickable ' + overlap}>
                  <JobActivityCard key={i} card={cardArray[i]} modalCard={cardArray[i]} show={show} border={border} borderColor={borderColor} />
                </div>
              </div>)
            }
        } else {
          if (border) {
            // push next left card
            cardList.push(
              <div key={i} className='row'>
                <div className='history-col-xs-2 visible-xs-block full-height-bar'>
                  <CircleDate cardDate={cardArray[i].date} color={borderColor} />
                </div>
                <div  onClick={show}  className='history-col-sm-5 history-col-xs-9 left-card clickable'>
                  <JobActivityCard key={i} card={cardArray[i]} modalCard={cardArray[i]} show={show} border={border} borderColor={borderColor} />
                </div>
                <div className='history-col-sm-1 hidden-xs'>
                  <CircleDate cardDate={cardArray[i].date} color={borderColor} />
                </div>
              </div>)
          } else {
            // push next right card
            cardList.push(
              <div key={i} className='row'>
                <div className='history-col-xs-2 history-col-sm-1 history-col-sm-offset-5 full-height-bar'>
                  <CircleDate cardDate={cardArray[i].date} color={borderColor} />
                </div>
                <div  onClick={show} className='history-col-sm-5 history-col-xs-9 right-card clickable'>
                  <JobActivityCard card={cardArray[i]} modalCard={cardArray[i]} show={show} border={border} borderColor={borderColor} />
                </div>
              </div>)
          }
        }
      }
      }
      cardList.push(<div key={'the-row'} className='row hidden-xs' style={{height: '20px'}} />)
    }
    let styleCenter = {
      margin: '0 auto',
      float: 'none'
    }

    if (cardList.length === 0) {
      if (!this.state.loading) {
        cardList.push(<h3 key='no history'>No Job History</h3>)
      }
    } else {
      cardList.push(<div key='a key' id='blackbar' />)
    }

    let loadMoreButton
    // if there is an even 30 then it has more to load. But this does not take into account having an even multiple of 30 jobs. Need to improve
    if (cardArray.length !== 0 && cardArray.length % 30 === 0 && !this.state.loading) {
      loadMoreButton = (<div className='row pull-down-xs-2 text-center'>
        <a style={{fontWeight: 600}} onClick={this.loadMoreHistory}>Load More</a>
      </div>)
    }
    let loadingImage
    if (this.state.loading) {
      loadingImage = <img src='/common/latest/images/play/spinner.gif' alt='loading' className='img-responsive center-block pull-down-xs-2' />
    }

    let loginData = this.props.loginData
    let customerAddresses = []
    for (let i = 0; i < loginData.customer.addresses.length; i++) {
      let addressData = loginData.customer.addresses[i]
      let customerAddress = addressData.streetAddress + ', '+ addressData.city
      customerAddresses.push(customerAddress)
    }

    return (
      <div className='container-cards' style={{marginBottom: 15}}>
        <div className='row' >
          <JobDetailsModal show={this.state.showJobDetailsModal} hide={this.closeJobDetailsModal} description={this.state.modalCard ? this.state.modalCard.content : null} modalCard={this.state.modalCard ? this.state.modalCard.mobileJob : null} actualCost={this.state.modalCard ? this.state.modalCard.mobileTask.cost : 0} showEditTask={this.openEditTaskModal} showSkipJob={this.openSkipJobModal}/>
          <TaskEditModal task={this.state.modalTasks} show={this.state.showEditTaskModal} hide={this.closeEditTaskModal} actualCost={this.state.modalCard ? this.state.modalCard.mobileTask.cost : 0} openUpgradeServiceModal={this.openUpgradeServiceModal} openUpgradeFrequencyModal={this.openUpgradeFrequencyModal} openUpgradeScheduleModal={this.openUpgradeScheduleModal} openUpdateInstructionsModal={this.openUpdateInstructionsModal} fullComponent={true}/>
          <UpgradeServiceModal show={this.state.showUpgradeServiceModal} hide={this.closeUpgradeServiceModal} actualCost={this.state.modalCard ? this.state.modalCard.mobileTask.cost : 0} task={this.state.modalCard ? this.state.modalCard.mobileJob : null} addressId={this.state.currentlySelectedAddressId} openNotificationModal={this.openNotificationModal} pricingArray={this.state.pricingArray}/>
          <UpgradeFrequencyModal show={this.state.showUpgradeFrequencyModal} hide={this.closeUpgradeFrequencyModal} actualCost={this.state.modalCard ? this.state.modalCard.mobileTask.cost : 0} task={this.state.modalCard ? this.state.modalCard.mobileJob: null} openNotificationModal={this.openNotificationModal} pricingArray={this.state.pricingArray}/>
          <UpdateInstructionsModal show={this.state.showUpdateInstructionsModal} hide={this.closeUpdateInstructionsModal} modalCard={this.state.modalCard ? this.state.modalCard : null} openNotificationModal={this.openNotificationModal}/>
          <JobFinishedModal show={this.state.showJobFinishedModal} hide={this.closeJobFinishedModal} modalCard={this.state.modalCard ? this.state.modalCard : null} login={this.props.loginData} addressId={this.state.currentlySelectedAddressId} openAcceptTaskModal={this.openAcceptTaskModal} openDeclineTaskModal={this.openDeclineTaskModal} openNotificationModal={this.openNotificationModal}/>
          <SkipJobModal show={this.state.showSkipJobModal} hide={this.closeSkipJobModal} modalCard={this.state.modalCard ? this.state.modalCard : null} openNotificationModal={this.openNotificationModal}/>
          <NotificationModal hide={this.closeNotificationModal} show={this.state.showNotificationModal} title={this.state.notificationTitle} content={this.state.notificationContent}/>
          <DeclineTaskModal
            show={this.state.showDeclineTaskModal}
            hide={this.closeDeclineTaskModal}
            goBack={this.openJobFinishedModal}
            modalCard={this.state.modalCard ? this.state.modalCard : null}
            openNotificationModal={this.openNotificationModal} />
          <AcceptTaskModal
            show={this.state.showAcceptTaskModal}
            hide={this.closeAcceptTaskModal}
            authCode={this.state.authCode}
            modalCard={this.state.modalCard ? this.state.modalCard : null}
            instructions={this.state.instructions}
            openNotificationModal={this.openNotificationModal} />

          <div className='col-xs-12 history-wrap' style={styleCenter}>
            <div className='row pull-down-sm-1'>
              <div className='col-sm-5 col-xs-12'>
                <h3>Job History Timeline</h3>
              </div>
              <div className='col-sm-7 col-xs-12 text-right address'>
                <Address addresses={customerAddresses} curIndex={this.props.curAddressIndex} onChange={this.props.reportAddressChange} />
              </div>
            </div>
            {cardList}
          </div>
          {loadMoreButton}
          {loadingImage}
        </div>

      </div>
    )
  }
})


// WEBPACK FOOTER //
// ./src/components/history/history.jsx